import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/5c64f483/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Community patterns`}</h2>
    <p>{`These patterns are developed and maintained by members of the Carbon community. For support, contact the maintainers listed on each page. They are not supported by the core Carbon team.`}</p>
    <p>{`These patterns may change over time, and they may be incomplete or experimental. For work that has been approved for universal use by the Carbon governance board, see `}<a parentName="p" {...{
        "href": "/patterns/overview"
      }}>{`Carbon patterns`}</a>{`.`}</p>
    <p><em parentName="p">{`Some of this content is accessible to IBMers only.`}</em></p>
    <br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Community patterns`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/chatbot/overview"
            }}>{`Chatbots`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How to design chatbots for users using natural language.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/create-flows"
            }}>{`Create flows`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How to generate a new resource; compare adding.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/edit-pattern"
            }}>{`Edit`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How to make changes to an existing resource.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/export-pattern"
            }}>{`Export`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How to change the format of the object or resources as you are exporting externally from the system.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/generate-an-api-key"
            }}>{`Generate an API key`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Helps ensure users know what the key is for, the security implications, and the final destination.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/import-pattern"
            }}>{`Import`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Transfers data or objects from an external source into a system.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://pages.github.ibm.com/watson-health/docs/guidelines/content-design/using-the-adoption-patterns.html"
            }}>{`In-app learning`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Accessible to IBMers only.`}</em>{` A set of patterns to help users understand key features. Includes the welcome screen, getting started, in-context help and guidance, and what’s new/updates.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://pages.github.ibm.com/CDAI-design/CDAI-design-website/patterns/order-summary/usage"
            }}>{`Order summary`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Accessible to IBMers only.`}</em>{` A summary of a platform’s functionality, status, or individual service.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/community/patterns/remove-pattern"
            }}>{`Remove`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An action that moves information from one location to another. Compare deletion.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      